'use client'

import useNextRouter from '@/hooks/useNextRouter';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function HeaderSearch() {
    const [search, setSearch] = useState('')
    const router = useRouter()
    const pathname = usePathname()
    const { params: { blogSearch } } = useSetSearchParams()

    useEffect(() => {
        if (blogSearch) {
            setSearch(blogSearch)
        }
    }, [blogSearch])
    return pathname.includes('/blog') && (
        <form onSubmit={(e) => {
            e.preventDefault()
            search && router.push(`/blog/all?blogSearch=${search}`)
        }} className='flex h-8 bg-white border-neutral-200  p-1 rounded-md border items-center gap-1'>

            <input placeholder='Search blogs...'
                className='border-none text-sm w-full placeholder:text-xs placeholder:font-normal placeholder:text-neutral-500
                       bg-none focus:ring-0 focus:outline-none text-neutral-700 focus:border-none h-full'
                value={search}
                onChange={(e) => setSearch(e.target.value)} />
            <button type='submit' className='aspect-square text-xs block h-full rounded-lg bg-pink-gradient text-white'>
                <FontAwesomeIcon icon={faSearch} />
            </button>
        </form>
    );
}